define('ProductLine.RemoveStoreFromURL', [
    'ProductLine.Common.Url',
    'underscore'
], function ProductLineRemoveStoreFromURL(
    ProductLineCommonUrl,
    _
) {
    'use strict';

    var blacklistedParameters = [
        'custcol_sca_store_ds',
        'custcol_sca_store_id'
    ];

    ProductLineCommonUrl.preURLGenerated.install({
        name: 'compositeView',
        priority: 1,
        execute: function execute(params) {
            return _.filter(params, function filterFn(p) {
                return blacklistedParameters.indexOf(p.param) === -1;
            });
        }
    });
});
